import { render, staticRenderFns } from "./_supplierCosts.vue?vue&type=template&id=655d724f&scoped=true&"
import script from "./_supplierCosts.vue?vue&type=script&lang=js&"
export * from "./_supplierCosts.vue?vue&type=script&lang=js&"
import style0 from "./_supplierCosts.vue?vue&type=style&index=0&id=655d724f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655d724f",
  null
  
)

export default component.exports